module.exports = __webpack_public_path__ + "img/markImg.245dbaea.jpg";